import axios from 'axios';
import axiosjsonp from 'axios-jsonp';
import store from '@/store';
import { logWebHrCritical, logWebHrError } from '../logger/log-wrapper';
import jwtToObject from '@/lib/jwt-to-object';

const instance = axios.create({
  // baseURL: window.__APP__.SVC_API || process.env.API,
  crossDomain: true,
  // timeout: 1000,
  // headers: {
  //   'X-Custom-Header': 'foobar',
  // },
  // headers: {
  // },
  withCredentials: false,
});

instance.interceptors.request.use(function (config) {
  config.url = `${window.__APP__.SVC_API || process.env.API}${config.url}`;
  return config;
});

instance.interceptors.response.use(
    (response) => {
      const token = response.headers['authorization'];
      if (token && !store.state.token && token !== store.state.token) {
          const varsOrigin = jwtToObject(store.state.token);
          const originalTenantId = varsOrigin['bid'];
          const varsTokenFromResponse = jwtToObject(token);
          const newTenantId = varsTokenFromResponse['bid'];

          logWebHrCritical({
              message: 'token mismatch from internal state and actual usage',
              metadata: {
                  originalTenantId,
                  newTenantId,
              },
              source: 'http',
          });
      }
      return response;
    },
    (error) => {
        if (error.response && error.response.status === 401) {
            const isTokenExpired = (token) => {
                const decodedToken = jwtToObject(token);
                const currentTime = Date.now() / 1000;
                return decodedToken.exp < currentTime;
            };

            const tokenExpired = isTokenExpired(store.state.token);

            logWebHrError({
                message: 'there were errors with 401 status',
                metadata: {
                    tenantIdFromStore: store.state.tenantId,
                    isTokenExpired: tokenExpired,
                },
                source: 'http'
            })
        }

      return Promise.reject(error);
    }
);



const jsonpIntance = axios.create({
  adapter: axiosjsonp,
});
const jsonp = (window.jsonp = jsonpIntance.get);

const get = ({ url, query, headers }) =>
  instance.get(url, { params: query, headers }).then(({ data }) => data);

const http = {
  get,
  jsonp,
};

export default http;
export { get, jsonp };
